export default "__VITE_ASSET__91d9ad1a__"